import ModalCreate from './CreateModal';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

const TableToolbar = (props) => {

    return (
        <Toolbar
        sx={{
            pl: { sm: 1 },
            pr: { xs: 1, sm: 1 },
          }}>
          <ModalCreate/>
          <Box sx={{
            ml: 2,
            mb: 2
          }}>
          <TextField id="standard-basic"  variant="standard" label="Buscar" type="search" onChange={ e => props.queryData(e.target.value)}/>
          </Box>
        </Toolbar>
    )
}

export default TableToolbar;